import { OPEN_SNACKBAR, CLOSE_SNACKBAR } from "./actionTypes";
import { getSnackbarMessage, snackbarIsOpen } from "./selectors";
import { getLocalizedString } from "@icarius-localization/strings";

export const openSnackbarAction = ({ msg, duration = 5000, path, severity }) => (dispatch, getState) => {
  const state = getState();
  const currentMsg = getSnackbarMessage(state);
  const isOpen = snackbarIsOpen(state);

  // Si hay un snackbar referente al socket, no muestra los otros
  if (isOpen && currentMsg === getLocalizedString("noConnection") && msg !== getLocalizedString("connectionRestored") && msg !== getLocalizedString("noConnection")) {
    return;
  }

  if (!navigator.onLine && msg !== getLocalizedString("noConnection") && msg !== getLocalizedString("connectionRestored")) {
    return;
  }

  dispatch({
    type: OPEN_SNACKBAR,
    payload: { msg, duration, path, severity },
  });
}

export const closeSnackbarAction = (dispatch) => dispatch({ type: CLOSE_SNACKBAR });
